import { render, staticRenderFns } from "./SelectedSectionItem.vue?vue&type=template&id=a6addcae&scoped=true"
import script from "./SelectedSectionItem.vue?vue&type=script&lang=ts"
export * from "./SelectedSectionItem.vue?vue&type=script&lang=ts"
import style0 from "./SelectedSectionItem.vue?vue&type=style&index=0&id=a6addcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6addcae",
  null
  
)

export default component.exports